import React, {useEffect, useState} from 'react'
import {IBatch} from '../../api/IRecipe'
import {getSuggestedBatches} from '../../api/api'
import {useNavigate} from "react-router-dom";
import {START_BATCH} from "../../routes";
import {BatchCard} from "../batch/components/BatchCard";
import { Container, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BatchListPage = (): JSX.Element => {
  const { t } = useTranslation();
  const [batches, setBatches] = useState<IBatch[]>([])
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate();

  useEffect( () => {
    const fetch = async() => {
      try {
        const allBatches = await getSuggestedBatches()
        setBatches(allBatches)
        setIsLoading(false)
      } catch (err) {
        setError(err)
        setIsLoading(false)
      }
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
    fetch()
  }, []);

  if (isLoading) {
    return (
        <Container>
          {t('common.loading')}
        </Container>
    )
  }

  return (
    <Container sx={{marginBottom: '2rem'}}>
      <Grid container spacing={{xs: 1}}>
        {batches.map((batch, idx) => (
          <Grid item xs={12} md={6} lg={4} key={batch.id || idx}>
            <BatchCard batch={batch} onClick={() => {navigate(START_BATCH, {state: {suggestedBatch: batch}})}} />
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}

export default BatchListPage
